/**
 * ClearIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ClearIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.215 8.498a.91.91 0 0 1 1.287 1.287L13.286 12l2.216 2.215a.91.91 0 0 1-1.287 1.287L12 13.286l-2.215 2.216a.91.91 0 0 1-1.287-1.287L10.714 12 8.498 9.785a.91.91 0 0 1 1.287-1.287L12 10.714z" />
    <path
      fillRule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 1.819A8.18 8.18 0 0 0 3.819 12 8.18 8.18 0 0 0 12 20.181 8.18 8.18 0 0 0 20.181 12 8.18 8.18 0 0 0 12 3.819"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ClearIcon = makeIcon('ClearIcon', ClearIconSvg)
